<template>
  <div class="square-card" :class="{ opacityHalf: opacityHalf }">
    <div class="card-title">
      <i :class="leadingIcon" />
      <p>{{ $t(title) }}</p>
    </div>
    <p class="num">
      {{ number }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'SquareCard',
  props: {
    title: {
      type: String,
      default() {
        return this.$t('續辦提醒');
      },
    },
    leadingIcon: {
      type: String,
      default: 'icon-remind-outline',
    },
    number: {
      type: Number,
      default: 0,
    },
    opacityHalf: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.square-card {
  @include flex_align;
  flex-direction: column;
  justify-content: center;
  padding: 12px;
  position: relative;
  overflow: hidden;
  min-height: 140px;
  border-radius: 20px;
  border: solid 1px var(--blue-30);
  background-color: var(--white);
  &.opacityHalf {
    opacity: 0.5;
  }
  .card-title {
    @include flex;
    @include flex_align;
    justify-content: center;
    color: var(--gray-900);
    i {
      font-size: 24px;
    }
    p {
      @include auto_margin_left(4px);
      font-size: 1.125rem;
      text-align: center;
      font-weight: bold;
      line-height: 1.43;
    }
  }
  .num {
    @include auto_margin_top(8px);
    font-size: 2.5rem;
    font-weight: bold;
    line-height: 1.2;
    letter-spacing: 1px;
    color: var(--blue-500);
  }
}
</style>
